var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('i',{staticClass:"fas fa-times clickable",on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }